import React from "react";
import data from "./data";
import { Select } from "../../../design-system";

export default (props) => {
  const options = data.map((estado) => ({
    value: estado.id,
    label: estado.state_name,
  }));

  function onChange(e) {
    const value = e.target.value;
    if (props.onChange) {
      const state = data.find((st) => value === st.id);
      if (state) {
        props.onChange(state.id, state.state_name, state.uf_code);
      }
    }
  }

  // Resolve the selected state by id, state_name, or uf to support legacy/alternative props.selected formats
  const selectedState = data.find(
    (st) =>
      st.id === props.selected ||
      st.state_name === props.selected ||
      st.uf === props.selected
  );

  return (
    <Select
      label="Estado"
      name="state_location"
      value={selectedState ? selectedState.id : ""}
      options={options}
      disabled={props.disabled}
      onChange={onChange}
      className={props.className}
    />
  );
};



// WEBPACK FOOTER //
// ./src/_components/Address/StateLocation/index.jsx